/* eslint-disable indent */
export default [
  {
    title: "案件管理",
    link: "newlylist",
    key: "debtor:view",
    cur: "0",
    icon: "profile",
    // cur用户高亮显示对应的title
  },
  {
    title: "分期管理",
    link: "payback",
    key: "loan:lists",
    cur: "1",
    icon: "money-collect",
  },
  {
    title: "案款管理",
    link: "collectionAmount",
    key: "payee:lists",
    cur: "Z",
    icon: "transaction",
  },
  {
    title: "案件委托",
    link: "entrust",
    key: "entrust:agent,management:manage",
    cur: "W-0",
    other: true,
    icon: "block",
    child: [
      {
        title: "委托代理",
        link: "entrust",
        key: "entrust:agent",
        cur: "W-0",
        other: true,
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/weituodaili.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/weituodaili1.png",
      },
      {
        title: "委托管理",
        link: "management",
        key: "management:manage",
        cur: "W-1",
        other: true,
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/weituoguanli.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/weituoguanli1.png",
      },
    ],
  },
  {
    title: "案件反馈",
    link: "Infomation",
    key: "Infomation:lists",
    cur: "Y",
    icon: "solution",
  },
  // {
  //   title: '委托管理',
  //   link: null,
  //   key: 'debtor:view',
  //   cur: "X"
  // },
  {
    title: "档案管理",
    link: "letters",
    key: "test",
    // key: 'letters:view',
    cur: "L",
    icon: "hdd",
    child: [
      {
        title: "律师函件",
        link: "letters",
        key: 'letters:view:index',
        // key: "test",
          // key: 'letters:view',
        cur: "L",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/lvshihan.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/lvshihan1.png",
      },
    ],
  },
  // {
  //   title: '档案管理',
  //   link: 'letters',
  //   key: 'letters:lists',
  //   cur: 'L'
  // },
  {
    title: "统计管理",
    link: "litigationStatistics",
    other: true,
    key: "statis:cause,statis:statistics:lists,statis:addCount:lists,statis:loan:lists,statis:cancel:lists",
    cur: "4-0",
    icon: "project",
    child: [
      {
        title: "案件统计",
        link: "litigationStatistics",
        key: "statis:cause",
        other: true,
        cur: "4-0",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/anjian.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/anjian1.png",
      },
      {
        title: "法院统计",
        link: "caseStatistics",
        other: true,
        key: "statis:statistics:lists",
        cur: "4-1",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/fayuan.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/fayuan1.png",
      },
      // {
      //   title: '标的及费用统计',
      //   link: 'costStatistics',
      //   key: '4-2'
      // },
      {
        title: "新增统计",
        link: "Analysis",
        key: "statis:addCount:lists",
        other: true,
        cur: "4-3",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/xinzeng.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/xinzeng1.png",
      },
      {
        title: "案款统计",
        link: "Anclear",
        cur: "4-5",
        key: "statis:loan:lists",
        other: true,
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/ankuan.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/ankuan1.png",
      },
      {
        title: "分期统计",
        link: "Stages",
        key: "statis:credit:lists",
        other: true,
        cur: "4-6",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/fenqi.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/fenqi1.png",
      },
      {
        title: "开庭统计",
        link: "openHall",
        key: "statis:openHall:lists",
        other: true,
        cur: "4-7",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/kaitin.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/kaitin1.png",
      },
      {
        title: "文书统计",
        link: "referee",
        key: "statis:referee:lists",
        other: true,
        cur: "4-8",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/wenshu.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/wenshu1.png",
      },
      {
        title: "费用统计",
        link: "causeFee",
        key: "statis:causeFee:lists",
        other: true,
        cur: "4-9",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/feiyong.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/feiyong1.png",
      },
      {
        title: "进度统计",
        link: "stepStatistics",
        key: "statis:step:lists",
        other: true,
        cur: "4-10",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/jindu.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/jindu1.png",
      },
      {
        title: "作废统计",
        link: "nullify",
        key: "statis:cancel:lists",
        other: true,
        cur: "4-4",
        icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/zuofei.png",
        icon1:
          "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/zuofei1.png",
      },
    ],
  },
  {
    title: "基础管理",
    link: "directoryManage",
    key: "court:list,accsuer:index,team:index,over:index,car:index,reason:index",
    cur: "3-0",
    other: true,
    icon: "setting",
    child: [],
  },
];
